<div class="min-h-screen flex flex-col">
  <app-basic-header-layout
    *appModeFull
    class="checkout-header"
    [logo]="logoName"
    [logoAlt]="'checkout.header.logo' | translate"
  ></app-basic-header-layout>

  <main class="checkout-content container">
    <header
      [class.checkout-content__header--large]="hasLargeColumn"
      class="checkout-content__header"
    >
      <app-back-link
        class="checkout-content__header__link"
        [ariaLabel]="backLinkAriaLabel"
        [backLink]="backLink"
      ></app-back-link>

      <h1 class="title-5 checkout-content__header__title">
        {{ title }}
      </h1>
    </header>

    <div
      [class.checkout-content__column--large]="hasLargeColumn"
      class="checkout-content__column checkout-content__column--left"
    >
      <p *ngIf="description" class="body-sm checkout-content__description">
        {{ description }}
      </p>

      <ng-content></ng-content>
    </div>

    <aside
      *ngIf="hasAside"
      class="checkout-content__column checkout-content__column--right"
    >
      <ng-content select="[right-column]"></ng-content>
    </aside>
  </main>

  <app-footer class="mt-auto"></app-footer>
</div>
